import { registerPlugin } from '@capacitor/core';
const Enroll = registerPlugin('Enroll', {
    web: () => import('./web').then((m) => new m.EnrollWeb()),
});
export * from './definitions';
export { Enroll };
//# sourceMappingURL=index.js.map